module.exports = __webpack_public_path__ + "public/files/img/school.abec2242.png";